import React, { Component } from 'react';
import './Input.css';

class Radio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: '',
      isChecked: this.props.defaultChecked || this.props.checked || false
    };
  }

  handleOptionChange = (event) => {
    this.setState({
      selectedOption: event.target.value
    });
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  render() {
    const {
      id: idInput = '0',
      required: requiredInput = false
    } = this.props;

    return (
      <div className={`input ${this.props.modifier ? this.props.modifier : ''}`}>
        <input
          className="input__radio"
          type="radio"
          name={this.props.name}
          id={idInput}
          value={this.props.value}
          onChange={this.handleOptionChange}
          required={requiredInput}
          defaultChecked={this.state.selectedOption === this.props.value || this.state.isChecked}
        />
        <label className="input__label" htmlFor={idInput} dangerouslySetInnerHTML={{ __html: this.props.label }} />
      </div>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Input/Radio.js